export default {
  getTableSettings: (state) => state.tableSettings,
  getUsers: (state) => state.users,
  getIsTableLoading: (state) => state.isTableLoading,
}
